import React, { useState } from "react";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [successMessage, setSuccessMessage] = useState("");

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    setSuccessMessage("Your message has been sent successfully!");
    setFormData({
      name: "",
      email: "",
      message: "",
    });
  };

  return (
    <>
      {/* <Navigation /> */}
      <div className="section" id="section-contact">
        <div className="content flex justify-between items-start mb-6">
          <div className="titles">
            <div className="title text-xl font-bold">Contact Us</div>
          </div>
        </div>

        <form
          onSubmit={handleSubmit}
          className=" mx-auto bg-white p-6 rounded-lg shadow-md"
        >
          {/* Name Field */}
          <div className="mb-4">
            <label
              htmlFor="name"
              className="block text-gray-700 font-semibold mb-2"
            >
              Full Name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="ej.: Aman Singh"
              className="w-full px-4 py-2 border border-[#e3e3e33c] rounded-full focus:outline-none bg-[#0000] placeholder:text-xs"
            />
          </div>

          {/* Email Field */}
          <div className="mb-4">
            <label
              htmlFor="email"
              className="block text-gray-700 font-semibold mb-2"
            >
              Email Address
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="example@domain.com"
              className="w-full px-4 py-2 border border-[#e3e3e33c] rounded-full focus:outline-none bg-[#0000] placeholder:text-xs"
            />
          </div>

          {/* Message Field */}
          <div className="mb-4">
            <label
              htmlFor="message"
              className="block text-gray-700 font-semibold mb-2"
            >
              Message
            </label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              placeholder="To Write"
              rows="5"
              className="w-full px-4 py-2 border border-[#e3e3e33c] rounded-2xl focus:outline-none  bg-[#0000] placeholder:text-xs"
            ></textarea>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className=" px-12  border py-[12px] border-[#e3e3e33c] hover:border-[#f0edcc]  transition-all  cursor-pointer text-sm rounded-full text-[#fff]"
          >
            SUBMIT
          </button>

          {/* Success Message */}
          {successMessage && (
            <p className="mt-4 text-green-600 font-semibold text-center">
              {successMessage}
            </p>
          )}
        </form>
      </div>
    </>
  );
};

export default ContactUs;
